import type { Device } from '../services/devicesApi';

/**
 * Devices that count toward Configure-home preflight/deploy gates.
 * Offline or decommissioned inventory must not block progress on an active pilot device.
 */
export function deviceCountsTowardSetupRolloutGate(device: Device): boolean {
  const lifecycle = String(device.lifecycle_summary?.state || '').trim().toLowerCase();
  if (lifecycle === 'decommissioned') return false;

  const prov = String(device.provisioning_status || '').trim().toLowerCase();
  if (prov === 'decommissioned' || prov === 'pending_activation' || prov === 'pending_approval') {
    return false;
  }

  if (device.edge_alive === false) return false;

  if (device.edge_alive === true) return true;

  const liveness = String(device.edge_liveness_status || '').trim().toLowerCase();
  if (liveness === 'ok' || liveness === 'up') return true;

  const status = String(device.status || '').trim().toLowerCase();
  if (status === 'online') return true;

  const age = device.heartbeat_age_s;
  const threshold = Number(device.edge_offline_threshold_sec) || 300;
  if (typeof age === 'number' && age > threshold) return false;

  if (status === 'offline') return false;
  if (liveness === 'down' || liveness === 'offline') return false;

  return prov === 'activated' || status === 'activated' || status === 'deployed';
}

export function filterGateDeviceStates<T extends { countsTowardSiteGate: boolean }>(rows: T[]): T[] {
  return rows.filter((row) => row.countsTowardSiteGate);
}
